export default "__VITE_ASSET__cjMK0_91__"